<template>
  <div class="header clear p-lr-188">
    <div class="head clear">
        <div class="logo ov"><img @click="goIndex" :src="webLogo" /></div>
          <div class="nav">
            <a v-for="(item, index) in nav" :key="index" @click.stop="path(item.path)">
                <div v-if="item.name == 'preciousMetal'" :class="[path_active == '/preciousMetal' ? 'c-fcd535 nav-title font-22' : 'nav-title font-22']">
                  {{ item.title }}
                  <i :class="[isSelect2 ? 'rotate el-icon el-icon-caret-bottom' : 'el-icon el-icon-caret-bottom']" style="color: #000000;"></i>
                </div>
                <!-- <div v-else-if="item.name == 'profit_index'" :class="[path_active == '/profit_index'||path_active == '/currency'|| path_active == '/subscription'? 'c-fcd535 nav-title font-22' : 'nav-title font-22']">
                  {{ item.title }}
                  <i :class="[isSelect ? 'rotate el-icon el-icon-caret-bottom' : 'el-icon el-icon-caret-bottom']" style="color: #000000;"></i>
                </div>
                <div v-else-if="item.name == 'sign'" :class="[path_active == '/sign'|| path_active == '/benefits' ? 'c-fcd535 nav-title font-22' : 'nav-title font-22']">
                  {{ item.title }}
                  <i :class="[isSelect3 ? 'rotate el-icon el-icon-caret-bottom' : 'el-icon el-icon-caret-bottom']" style="color: #000000;"></i>
                </div> -->
                <div v-else :class="[path_active == item.path ? 'c-fcd535 nav-title font-22' : 'nav-title font-22']">{{ item.title }}</div>

                <div class="select-box" v-show="item.name == 'preciousMetal' && isSelect2">
                  <!-- <div class="select" @click="jump('/deal')">{{$t('currency.bb')}}</div>
                  <div class="select" @click="jump('/deal_c')">{{$t('currency.hy')}}</div>
                  <div class="select" @click="jump('/deal_jg')">{{$t('currency.jg')}}</div>
                  <div class="select" @click="jump('/preciousMetal')">{{$t('langNew.yxhy')}}</div>
                  <div class="select" @click="jump('/contractTransaction')">{{$t('currency.jg')}}</div> -->

                  <!-- <div class="select set" @click="jump('/deal')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('currency.bb')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div> -->
                  <div class="select set" @click="jump('/deal_c')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('currency.hy')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div>
                  <div class="select set" @click="jump('/deal_jg?group=1')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('currency.jg')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div>
                 <!-- <div class="select set" @click="jump('/preciousMetal')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('langNew.yxhy')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div>
                  <div class="select set" @click="jump('/contractTransaction')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('currency.jg')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div> -->

                </div>
                <div class="select-box" v-show="item.name == 'profit_index' && isSelect">
                  <!-- <div class="select" @click="jump('/profit_index')">{{$t('bzhl.title')}}</div>
                  <div class="select" @click="jump('/currency')">{{$t('wydb.db')}}</div>
                  <div class="select" @click="jump('/subscription')">{{$t('xbsg.title')}}</div> -->

                  <div class="select set" @click="jump('/profit_index')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('bzhl.title1')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div>
                  <!-- <div class="select set" @click="jump('/currency')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('wydb.db')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div> -->
                  <!-- <div class="select set" @click="jump('/subscription')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('xbsg.title')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div> -->
                </div>
                <div class="select-box" v-show="item.name == 'sign' && isSelect3">
                  <!-- <div class="select" @click="jump('/sign')">{{$t('langNew2.qdjl')}}</div>
                  <div class="select" @click="jump('/benefits')">{{$t('langNew2.flzq')}}</div> -->

                  <!-- <div class="select set" @click="jump('/sign')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('langNew2.qdjl')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div> -->
                  <div class="select set" @click="jump('/benefits')">
                    <div class="flex-b col-c">
                      <div class="font-22">{{$t('langNew2.flzq')}}</div>
                      <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                    </div>
                  </div>
                </div>
            </a>
            <!-- <a @click.stop="path('/settingNew')">
              <div :class="[path_active == '/settingNew' ? 'c-fcd535 nav-title font-22' : 'nav-title font-22']">{{ $t('bank.text5')}}</div>
            </a> -->
            <!-- <a @click="createSimulation" v-show="temp_user">
              <div class="font-22" :class="[path_active == '/index'&&mnzh ? 'c-fcd535' : 'c-fff']">{{ $t('langNew2.cjxnzh')}}</div>
            </a> -->
          </div>

          <dl class="login clear">
            <dt v-if="token">
              <img class="login-name w-30 h-30 m-t-24 cursor" style="height:30px" @click="goRecharge" src="@/assets/new3/tongzhi.png" alt="" />
            </dt>
            <dt v-if="token">
              <a class="login-name" :class="[path_active == '/table1' ? 'c-fcd535' : 'c-fff']" @click="path('/table1')">{{ btn[2] }}</a>
            </dt>
            <dd><a v-if="!token" @click="path('/register')">{{ $t('register.register_btn') }}</a></dd>
            <dt>
              <a class="">
                <span class="login-name login-box" v-if="!token" @click="!token && path('/login')">
                  <span class="t-center" style="font-size: 15px; color: #000;justify-content: center;">{{ $t('login.list')[3] }}</span>
                </span>
                <div class="login-user-box" v-else>
                  <span class="login-name" :class="[path_active == '/setting' ? 'c-fcd535' : 'c-fff']">
                    <img class="w-25 h-25" src="@/assets/home/me.png" />
                  {{ phone | mdName }}
                  </span>
                  <div class="set-box login-box box-shadow-14">


                    <!-- <div class="set set-hover" v-for="(item, index) in menus" :key="index" @click.stop="path(item.path)">
                      <div class="flex-b col-c">
                        <div class="font-22">{{ item.title }}</div>
                        <img class="w-20 h-20" src="@/assets/home/xiahuasanjiao.png" />
                      </div>
                      <div class="font-16 c-7d7d7d" v-if="index==0">{{ $t('person.smrz.title') }}</div>
                      <div class="font-16 c-7d7d7d" v-if="index==1">{{ item.title }}</div>
                    </div> -->

                    <div class="position-box">
                      <div class="cotainer">
                        <div class="user-info m-b-30 relative">
                          <div class="flex col-c font-40" style="padding:0 .18rem" v-if="token">
                            <img class="w-60 m-r-20 cursor" style="height:.6rem" @click="goHome" src="@/assets/new3/touxiang.png" alt="">
                            <div class="info-box">
                              <div class="info-head c-000">
                                <!-- <span class="el-dropdown-link font-26 font-b c-fff">
                                  {{userName | mdName}}
                                </span> -->
                                <el-dropdown class="flex-content row-l br-20 m-b-20" trigger="click" @command="handleCommand">
                                  <span class="flex-content el-dropdown-link font-22 c-fff " v-if="!isMn&&(userName == userInfo.name)">
                                    {{userName | mdName}}<i class="font-30 el-icon-arrow-down el-icon--right"></i>
                                  </span>
                                  <span class="flex-content el-dropdown-link font-22 c-000" v-else>
                                    {{$t('langNew.mnzh')}}<i class="font-30 el-icon-arrow-down el-icon--right"></i>
                                  </span>
                                  <el-dropdown-menu slot="dropdown" class="dropdown-menu">
                                    <el-dropdown-item class=" t-center font-30 p-10" command="1" v-if="userName != userInfo.name">{{userInfo.name | mdName}}</el-dropdown-item>
                                    <el-dropdown-item class=" t-center font-30 p-10" command="2" v-if="userInfoDemo.name&&(userName != userInfoDemo.name)">{{$t('langNew.mnzh')}}</el-dropdown-item>
                                    <template v-if="temp_user">
                                      <el-dropdown-item class=" t-center font-30 p-10 cursor" command="3" v-if="!isMn && !userInfoDemo.name" @click.stop="demologin">{{$t('langNew.mnzh')}}</el-dropdown-item>
                                    </template>
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </div>
                              <div class="flex-content c-ccc font-20" style="justify-content: flex-start;"><a class="font-22"> UID: </a>{{userID}}</div>
                            </div>
                          </div>
                          <div v-else class="info-box cursor" @click="login">
                             <div class="info c-000 font-36 bolder">{{$t('langNew.qdl')}}</div>
                          </div>
                          <!-- <img class="new-icon absolute cursor" @click="centerDialogVisible1 = false" src="@/assets/new5/Close.png" alt=""> -->
                        </div>
                        <ul class="ul-box wow fadeInUp animated">
                          <li class="li c-fff bg-000 cursor" tag="li" @click="kyc">
                            <img class="icon" src="@/assets/new3/shenfen.png" alt="">
                            <div class="text c-fff font-22">{{$t('user.zhyz')}}</div>

                            <img class="arrow m-r-10" src="@/assets/new5/succeed@2x.png" v-if="base_auth_status==2" alt="">
                            <img class="arrow" src="@/assets/new3/jiantou-you@2x.png" alt="">
                          </li>
                          <li class="li c-fff bg-000 cursor" tag="li" @click="goPage('/accountRecord')">
                            <img class="icon" src="@/assets/new3/jilu.png" alt="">
                            <div class="text c-fff font-22">{{$t('user.zhjl')}}</div>
                            <img class="arrow" src="@/assets/new3/jiantou-you@2x.png" alt="">
                          </li>
                          <!-- <li class="li c-fff bg-000 cursor" tag="li" @click="goPage('/invite')">
                            <img class="icon" src="@/assets/new3/yaoqing.png" alt="">
                            <div class="text c-fff font-22">{{$t('user.yqhy')}}</div>
                            <img class="arrow" src="@/assets/new3/jiantou-you@2x.png" alt="">
                          </li> -->
                          <!-- <li class="li c-fff bg-000 cursor" @click="service" v-if="token">
                            <img class="icon" src="@/assets/new3/kefu.png" alt="">
                            <div class="text c-fff font-32">{{$t('langNew.lxwm')}}</div>
                            <img class="arrow" src="@/assets/new3/jiantou-you@2x.png" alt="">
                          </li> -->
                          <li class="li c-fff bg-000 cursor" tag="li" @click="goPage('/benefits')">
                            <img class="icon" src="@/assets/new3/liwu.png" alt="">
                            <div class="text c-fff font-22">{{$t('user.flzq')}}</div>
                            <img class="arrow" src="@/assets/new3/jiantou-you@2x.png" alt="">
                          </li>
                          <ul class="ul-box wow fadeInUp animated">
                            <li class="li c-fff bg-000 cursor" tag="li" @click="goPage('/editPassword')">
                              <img class="icon" src="@/assets/new3/shenfen.png" alt="">
                              <div class="text c-fff font-22">{{$t('user.dlmm')}}</div>
                              <img class="arrow" src="@/assets/new3/jiantou-you@2x.png" alt="">
                            </li>
                            <li class="li c-fff bg-000 cursor" tag="li" @click="goPage('/editPasswordTrade')">
                              <img class="icon" src="@/assets/new3/jilu.png" alt="">
                              <div class="text c-fff font-22">{{$t('user.jymm')}}</div>
                              <img class="arrow" src="@/assets/new3/jiantou-you@2x.png" alt="">
                            </li>
                          </ul>
                          <!-- <li class="li c-fff bg-000 cursor" tag="li" @click="aqzxOpen">
                            <img class="icon" src="@/assets/new5/anquan.png" alt="">
                            <div class="text c-fff font-32">{{$t('user.aqzx')}}</div>
                            <img class="arrow" src="@/assets/new5/jiantou-you@2x.png" alt="">
                          </li> -->
                          <!-- <li class="li c-fff bg-000" @click="select">
                            <img class="icon" src="@/assets/new5/yuyan.png" alt="">
                            <div class="text c-fff font-32">{{$t('user.yyxz')}}</div>
                            <div class="c-fff font-32">{{lgText}}</div>
                            <img class="arrow" src="@/assets/new5/jiantou-you@2x.png" alt="">
                          </li> -->
                        </ul>
                        <div class="btn-exit c-000 font-22 cursor p-tb-10 br-20" v-if="token" @click="loginOut">{{$t('user.tcdl')}}</div>
                        <div class="btn-exit c-000 font-22 cursor p-tb-10 br-20" v-else @click="login">{{$t('login.dl')}}</div>
                      </div>
                    </div>




                  </div>
                </div>
              </a>
            </dt>

            <dt class="login-lang relative">
              <span class="login-name c-fff">{{default_lang}}</span>
              <p class="br-20 box-shadow-14 p-20">
                <a class="p-tb-10"  :class="{'active-li': item.lang == default_lang }" v-for="(item, index) in lang" :key="index" @click="setLang(index)">{{ item.lang }}</a>
              </p>
            </dt>
          </dl>
    </div>

    <!-- 客服图标 -->
    <!-- <img src="@/assets/new5/kefulogo.png" class="serveimg" @click="serverfun" /> -->
    <!-- v-if="token" -->
    <!-- <img style="position: fixed;bottom: 30px;right: 30px;width:60px;height: 60px;z-index:999" src="@/assets/new5/kefulogo.png" @click="chatwoot"/> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { setLang, setToken,getLang } from "@/utils/auth";
import { getLogo,getCheckcode } from "@/api/index";
import homelogo from "@/assets/home/logo2.png";
import { tempLogin,getInfoUser } from '@/api/index'
import { getCenterLevel } from '@/api/asset'
import { Loading } from 'element-ui';

export default {
  props: {
    aoStyle: {
      type: Object,
      default: () => {
        return {
          background: "#0e1837",
          // position: "absolute"
        };
      }
    },
    navName: {
      type: String,
      default: () => {
        return {
          navName
        };
      }
    }
  },
  data() {
    return {
      btn: this.$t("nav.btn"),
      nav: this.$t("nav.nav"),
      nav2: this.$t("nav.nav2"),
      menus: this.$t("nav.menus"),
      lang: this.$t("nav.lang"),
      default_lang: '',
      logo: homelogo,
      isSelect: false,
      isSelect2: false,
      isSelect3: false,
      path_active:'',//导航标题下标显示
      // temp_user: false,
      mnzh:false,
      base_auth_status:'',
      temp_user: false,//是否开启模拟
      userName:'',
      userID: '',
      userInfo: {
        name: ''
      },
      userInfoDemo: {
        name: ''
      },
      isMn: false,
      isClickOne:false,
    };
  },
  computed: {
    ...mapGetters(["token", "phone"])
  },
  created(){
    // this.token = localStorage.getItem('token');

    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))||{name:''};
    this.userInfoDemo = JSON.parse(localStorage.getItem('userInfoDemo'))||{name:''};

    // this.theme = JSON.parse(localStorage.getItem('theme'));
    // this.isPwd = JSON.parse(localStorage.getItem('isPwd'));
    // this.lang = localStorage.getItem('language') || 'en';
    this.isMn = JSON.parse(localStorage.getItem('isMn')) || false;
    this.temp_user = JSON.parse(localStorage.getItem('temp_user')) || false;

    if(this.token){
      this.getCenterLevel();
      this.getInfo();
    }
  },
  mounted() {
    var key = getLang()
    var obj = this.lang.find(o => o.key == key)
    this.default_lang = obj.lang
    this.path_active = this.$route.path
    this.mnzh = localStorage.getItem('mnzh')
    // if (this.token) {
    //   this.nav = this.nav.concat(this.nav2);
    // }
    // this.getLogo();
    this.getSimulation()
    // this.getAsset();
    // this.getParams();
    // this.getLendMy();
    // this.getRenzheng();
  },
  methods: {
    serverfun(){
      _MEIQIA('showPanel');
      // if(this.token){
        // if(this.serverUrl){
        //   window.open(this.serverUrl);
        // }
      //else{
      //     this.$router.push('/');
      //   }
      // }else{
      //   this.$router.push('/login');
      // }
    },
    chatwoot(){
      window.$chatwoot.popoutChatWindow();
    },
    getInfo(){
        getInfoUser({}).then((res) => {
            let resData = res;
            this.userName = resData.name;
            // console.log(this.userName)
            this.userID = resData.id;
            localStorage.setItem('username',resData.name);
            localStorage.setItem('invitation_code',resData.invitation_code);
            localStorage.setItem('link',resData.link);
        }).catch(function(err){
            console.log(err)
        })
    },
    // 模拟登录
    demologin(){
      if(this.isClickOne){
        return
      }
      this.isClickOne = true
      Loading.service();
      let loadingInstance = Loading.service();
      let token = localStorage.getItem('token')
      this.$store.dispatch('login2', {token:token}).then((res) => {
        this.isMn = true;
        // console.log('模拟token',res.token)
        localStorage.setItem('token',res.token)
        setToken(res.token);
        localStorage.setItem('isMn',JSON.stringify(true));
        localStorage.setItem('userInfoDemo',JSON.stringify(res));
        this.isClickOne = false;
        this.$message({
          type: "",
          message: this.$t('login.cjmnzhcg')
        });
        loadingInstance.close();
        setTimeout(() => {
          // this.$router.push('/account');
          window.location.reload();
        }, 1000)
      }).catch(() => {
        loadingInstance.close();
      }).finally(() => {})

      // tempLogin({ token:1 }).then(res => {
      //   let resData = res;
      //   localStorage.setItem('token',resData.token);
      //   localStorage.setItem('isMn',JSON.stringify(true));
      //   localStorage.setItem('userInfoDemo',JSON.stringify(resData));
      //   // this.$toast.center(this.$t('login.cjmnzhcg'));
      //   this.$message({
      //     type: "",
      //     message: this.$t('login.cjmnzhcg')
      //   });
      //   setTimeout(() => {
      //     this.$router.push('/index');
      //     window.location.reload();
      //   }, 1000)
      // }).catch(function(err){
      //     console.log(err)
      // })
    },
    // 模拟账号退出登录
    exit(){
      localStorage.removeItem('token');
      localStorage.removeItem('isMn');
      localStorage.removeItem('userInfoDemo');
      if(this.userInfo){
         // localStorage.setItem('token',this.userInfo.token);

         this.$store.commit('SET_TOKEN', this.userInfo.token);
         setToken(this.userInfo.token);
         localStorage.setItem('token',this.userInfo.token);
         this.isMn = false;
         localStorage.setItem('isMn',JSON.stringify(false));
         localStorage.setItem('userInfo',JSON.stringify(this.userInfo));
         // this.mainLogin()

         // this.$router.push('/account');
         // window.location.reload();
         // setTimeout(() => {
         //   window.location.reload();
         // }, 1000)
         // this.getInfo();
         // this.getAsset();
         // this.getParams();
         // this.getLendMy();
      }else{
        this.$router.push('/login')
      }
      // window.location.reload();
    },
    handleCommand(command){
      // console.log(command)
      // 1为主账号isMn为false；2为模拟isMn为true；3开始登录模拟；4退出模拟
      if(command == 3){
        this.demologin()
      }else if(command == 4){
        this.exit()
      }else if(command == 2){
          // console.log(this.userInfoDemo)
          this.$store.commit('SET_TOKEN', this.userInfoDemo.token);
          localStorage.setItem('token',this.userInfoDemo.token);
          setToken(this.userInfoDemo.token);
          this.isMn = true;
          localStorage.setItem('isMn',JSON.stringify(true));
          localStorage.setItem('userInfoDemo',JSON.stringify(this.userInfoDemo));

          // this.$router.push('/account');
          window.location.reload();
          // this.getInfo();
          // this.getAsset();
          // this.getParams();
          // this.getLendMy();
      }else if(command == 1){
        // console.log("主token:",this.userInfo.token)

          this.$store.commit('SET_TOKEN', this.userInfo.token);
          localStorage.setItem('token',this.userInfo.token);
          setToken(this.userInfo.token);
          this.isMn = false;
          localStorage.setItem('isMn',JSON.stringify(false));
          localStorage.setItem('userInfo',JSON.stringify(this.userInfo));
          // this.mainLogin()

          // this.$router.push('/account');
          window.location.reload();
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000)
          // this.getInfo();
          // this.getAsset();
          // this.getParams();
          // this.getLendMy();
      }
    },
    goPage(path){
      this.$router.push({ path: path })
    },
    goHome(){
      this.$router.push('/index')
    },
    login(){
      this.$router.push('/login')
    },
    loginOut(){
      this.$store.dispatch("FedLogOut").then(() => {
        localStorage.removeItem("sbsxbz");
        localStorage.removeItem("sbsxIcon");

        localStorage.removeItem('token');
        localStorage.removeItem('area_code');
        localStorage.removeItem('city_code');
        localStorage.removeItem('bz');
        localStorage.removeItem('type');
        localStorage.removeItem('isMn');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('userInfoDemo');
        this.$router.push('/login')
        location.reload();
      });
    },
    // loginOut(){
    //     localStorage.removeItem('token');
    //     localStorage.removeItem('area_code');
    //     localStorage.removeItem('city_code');
    //     localStorage.removeItem('bz');
    //     localStorage.removeItem('type');
    //     localStorage.removeItem('isMn');
    //     localStorage.removeItem('userInfo');
    //     localStorage.removeItem('userInfoDemo');
    //     this.$router.push('/login')
    //  },
     // kyc认证
     kyc(){
       if(this.base_auth_status==2) return;
       this.$router.push({ path: '/authentication' })
     },
     // kyc是否认证
     getCenterLevel(){
         // this.$ajax.get('/web/getCenterLevel',{level:1}).then((res) => {
         //      let resData = res.data.data;
         //      console.log(res)
         //      console.log(resData)
         //      // if(res.data.code == 1000){
         //      //   // this.$toast.center(res.data.message);
         //      //   setTimeout(()=>{
         //      //     this.$router.push('/login');
         //      //   },1000)
         //      //   return false
         //      // }
         //      // this.name_auth_status = resData.name_auth_status;
         //      this.base_auth_status = resData.base_auth_status;
         //      // this.address_auth_status = resData.address_auth_status;
         //  }).catch(function(err){
         //      console.log(err)
         //  })

         getCenterLevel({level:1}).then(res=>{
           this.base_auth_status = res.base_auth_status;
         })

         // let params={
         //   lang: this.lang,
         //   app: 'pc',
         //   token: this.token,
         //   level:1
         // }
         // let that = this
         //  $.ajax({
         //    url: window.GLOBAL.HOST + "web/getCenterLevel",
         //    type: "GET",
         //    contentType: "application/json; charset=utf-8",
         //    dataType: "json",
         //    data: params,
         //    success: function(res) {
         //      console.log(res)
         //      console.log(res.data)
         //      if(res.code != 1000){
         //        let resData = res.data;
         //        that.base_auth_status = resData.base_auth_status;
         //      }
         //    },error: function(res) {
         //      that.$message({
         //        type: "error",
         //        message: res.message
         //      });
         //      return;
         //    }
         //  })
     },
    goRecharge(){
      this.$router.push('/notice')
    },
    getSimulation(){
      getCheckcode().then(res => {
        if(typeof res === 'string') res = JSON.parse(res);
        this.temp_user = res.temp_user;
      });
    },
    createSimulation(){
      this.$store.dispatch('login2', {}).then(() => {
        this.mnzh = true
        this.$message({
          type: "",
          message: this.$t('statusText[2]')
        });
        // this.$message({
        //   type: "warning",
        //   message: this.$t('pay.tbmmts')
        // });
        localStorage.removeItem('sbsxbz');
        localStorage.removeItem('sbsxIcon');
        if(this.path_active != '/index'){
          localStorage.setItem('mnzh',true)
          this.$router.push({ path: '/index' })
        }

      }).catch(() => {}).finally(() => {})
    },
    // getLogo(){
    //   getLogo({key: 'web_logo'}).then(res => {
    //     sessionStorage.setItem('web_logo',res)
    //     this.logo = res || homelogo
    //   })
    // },
    setLang(index) {
      var key = this.lang[index].key;
      setLang(key);
      this.$i18n.locale = key;
      localStorage.setItem('lang',key)
      location.reload()
    },
    path(path) {
      if (path) {
        // this.path_active = path
        // if(path=='/deal_c'){
        //   localStorage.setItem('type',2)
        // }
        // if(path=='/deal'){
        //   localStorage.setItem('type',1)
        // }
        if(path == '/preciousMetal'){
          this.isSelect = false;
          this.isSelect3 = false;
          this.isSelect2 = !this.isSelect2;
          localStorage.setItem('type',3);
          return false;
        }else if(path == '/profit_index'){
          this.isSelect2 = false;
          this.isSelect3 = false;
          this.isSelect = !this.isSelect;
          localStorage.setItem('type',3);
          return false;
        }else if(path == '/sign'){
          this.isSelect = false;
          this.isSelect2 = false;
          this.isSelect3 = !this.isSelect3;
          localStorage.setItem('type',3);
          return false;
        }else{
          this.$router.push({ path: path });
        }
      } else {
        this.$store.dispatch("FedLogOut").then(() => {
          localStorage.removeItem('mnzh');
          localStorage.removeItem('sbsxbz');
          localStorage.removeItem('sbsxIcon');
          location.reload();
        });
      }
    },
    jump(path){
      if(path=='/deal_c'){
        localStorage.setItem('type',2)
      }
      if(path=='/deal'){
        localStorage.setItem('type',1)
      }
      if(path=='/deal_jg'){
        localStorage.setItem('type',3)
      }
      if(path=='/preciousMetal'){
        localStorage.setItem('type',2)
      }
      if(path=='/contractTransaction'){
        localStorage.setItem('type',3)
      }
      this.$router.push({ path: path });
    },
    goIndex(){
      this.$router.push('/index');
    }
  },
  filters: {
      mdName: function (str) {
          if(str.length >= 7){
              return str.substr(0,3)+'****'+str.substr(7,str.split('').length)
          }else{
              return str;
          }
      }
  },
};
</script>

<style scoped lang="scss">
  .serveimg{position: fixed;z-index: 101;bottom: 50px;right: 50px;width: 80px;}
  .el-dropdown-link{
    height: auto !important;
    margin: 0 !important;
    color: #000000 !important;
  }
.header{ width:100%; height:80px;background: #fff;}
.header .head{ width:100%; margin:auto;}
.header .head .logo{ height:40px; float:left; margin:18px 0;cursor: pointer;}
.header .head .logo img{ display:block; height:40px;}
.header .head .nav{ height:80px; float:left;}
.header .head .nav a{ display:block; float:left; margin:0 20px; font-size:22px; line-height:80px; color:#000000;position: relative;}
.header .head .nav a:nth-child(3){
  margin-right: 20px;
}
.header .head .nav a:nth-child(4){
  margin-right: 20px;
}
.header .head .nav .nav-title .rotate{
  color: #fcd535 !important;
  transform-origin: center;
  transform: rotate(180deg);
}

.header .head .login{ height:.8rem; float:right; position:relative;}
.header .head .login dt span{ display:flex;justify-content: flex-start; cursor:pointer;}
.header .head .login dt p{ display: none;background-color: #fff; position:absolute; right:-45px;z-index: 10; width:180px; top:.8rem;  padding-bottom:10px; overflow:hidden;}
.header .head .login dt p a{ display: block; font-size:14px; line-height:24px; color:#000000;}
.header .head .login dt p a img{ height:14px; display:inline-block; vertical-align:middle; margin-right:5px;}
.header .head .login dt:hover span{ color:#fcd535;}
.header .head .login dt:hover p{ display:block;}
.header .head .login dt{ display:block; float:left; font-size:15px;height: .8rem;}
.header .head .login dt>a{ margin-left:20px; display:block;}
// .header .head .login dt a:hover{ color:#fcd535;}
.header .head .login dd{ display:block; float:left; font-size:14px; margin-left:30px;}
.header .head .login dt .login-box{color:#fff; background-color:#fcd535; border-radius:5px;}
.header .head .login dt .login-box span{
  width: 130px;margin: 22px 0; height: 35px;line-height: 35px;color: #fff;
}
.active-li{
  background-color: #fcd437;
  border-radius: .4rem;
}
.login-name{
  display:flex !important;
  justify-content: center !important;
  align-items: center;
  margin: 22px 0; height: 35px;line-height: 35px;font-size:15px;
}
.header .head .login .login-lang{
  width: 97px;text-align: center; color: #fff;font-size:14px;
}
.header .head .login dd a{ display:block;font-size:15px; width: 97px;text-align: center;margin: 22px 0; height: 35px;line-height: 35px; color:#000000; border: solid 1px #9f9f9f; border-radius:5px; overflow:hidden;}
.select-box{
    position: absolute;
    top: .8rem;
    left: 0;
    z-index: 999;
    width: 3.6rem;
    border-radius: 2px;
    padding: .15rem;
    background-color: #ffffff;
    box-shadow: 0px 11px 51px 0px rgba(0, 0, 0, 0.14);
  }
  .select-box .select{
    height: 34px;
    padding: 0 15px;
    color: #000000;
    line-height: 34px;
    font-size: 14px;
    text-align: left;
  }
  .select-box .select:hover{
    background-color: #fcd437;
    border-radius: 10px;
  }
  .login-user-box{
    height: .8rem;
  }
  .login-user-box:hover .set-box{
    display: block;
  }

  .set-box{
    display: none;
    width: 5.2rem;
    background-color: #ffffff !important;
    border-radius: .1rem;
    padding: .3rem .15rem;
    position:absolute; right:0; top:.8rem;z-index: 10; overflow:hidden;
  }
  .set-box .set:nth-child(1){
    margin-bottom: .2rem;
  }
  .set-box .set{
    border-radius: .1rem;
    padding:.15rem; overflow:hidden; color: #000000; font-size:.22rem;
  }
  .set-hover:hover{
    background-color: #fcd437;
  }

  .ul-box{
    width: 100%;
  }
  .ul-box .li{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .2rem;
    padding: .14rem .18rem;
    border-radius: .2rem;
  }
  .ul-box .li:hover{
    background-color: #fcd437;
  }
  .ul-box .li .icon{
    width: .4rem;
    height: .4rem;
  }
  .ul-box .li .arrow{
    width: .2rem;
  }
  .ul-box .li .text{
    flex: 1;
    margin: 0 .2rem;
  }
  .btn-exit{
    margin: .35rem 0;
    font-weight: bold;
    text-align: center;
    background-color: #fcd437;
  }
</style>



// WEBPACK FOOTER //
// src/components/AoNav.vue